import type { StageMeta } from './workflowStages';

/** Physical codes are intentionally opaque to the browser's route order. */
export const SERVICES_PWS_GENERATION_STAGE_ORDER = [620, 621, 622] as const;

export const servicesPwsGenerationStages: StageMeta[] = [
  { id: 'services-pws-requirement-intake', name: 'Define Service Requirement', description: 'Describe the service requirement and add supporting documents' },
  { id: 'services-pws-context-questions', name: 'Context Questions', description: 'Confirm document controls and answer focused questions' },
  { id: 'services-pws-generate', name: 'Generate PWS', description: 'Generate, edit, checkpoint, and export the Performance Work Statement' },
];
